<div class="nav-wrapper">
    <div class="nav-group">
      
        <mat-nav-list>
          <mat-list-item [class.active]="isActive(['/dashboard'])" [disabled]="!tracerAccess" (click)="tracerAccess && navigateTo('/dashboard')">
              <span class="item-label"><mat-icon class="icon-margin">dashboard</mat-icon> Übersicht</span>
          </mat-list-item>
          <mat-list-item  [class.active]="isActive(['/tasks', '/tasks/:id'])" [disabled]="!tracerAccess" (click)="tracerAccess && navigateTo('/tasks')">
              <span class="item-label"><mat-icon class="icon-margin">fact_check</mat-icon> Aufgaben</span>
          </mat-list-item>
<!--           <mat-list-item disabled [class.active]="isActive(['/task-groups'])" (click)="navigateTo('/task-groups')">
            <span class="item-label"><mat-icon class="icon-margin">group_work</mat-icon> Gruppen</span>
          </mat-list-item> -->
          <mat-list-item [class.glow]="isGlowing" [disabled]="!tracerAccess" [class.active]="isActive(['/finished-tasks', '/finished-tasks/:id'])" (click)="tracerAccess && navigateTo('/finished-tasks')">
            <span class="item-label"><mat-icon class="icon-margin">task</mat-icon> Erledigte Aufgaben</span>
          </mat-list-item>

          @if (buildEnvironment==="Narravero DEV " || buildEnvironment==="Narravero TEST ") {
            <mat-list-item [class.active]="isActive(['/tridys', '/tridys/:id'])" [disabled]="!tracerAccess" (click)="tracerAccess && navigateTo('/tridys')">
              <span class="item-label">
                <div class="d-flex align-items-center">
                  <span class="d-flex"><mat-icon class="icon-margin">qr_code</mat-icon> Tridy Liste </span>
                  <div class="badge ms-4 badge-primary">BETA</div>
                </div>
            </span>
            </mat-list-item>
          }

        </mat-nav-list>

    </div>

    <div class="text-center p-2">
      <small class="dev-note">{{buildEnvironment}} - {{version}} ( {{buildNumber}} )</small>
    </div>

      
<!--     <div class="bottom-icons">

        <mat-nav-list>
            <mat-list-item disabled>
                <span disabled class="item-label"><mat-icon class="icon-margin">check_circle</mat-icon> Erledigte Aufgaben</span>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item disabled>
                <span  class="item-label"><mat-icon class="icon-margin">help</mat-icon> Hilfe</span>
            </mat-list-item>
        </mat-nav-list>

        <button mat-button>
          <mat-icon>check_circle</mat-icon>
          Erledigte Aufgaben
        </button>
        <button mat-button>
          <mat-icon>help</mat-icon>
          Hilfe
        </button>
    </div> -->
</div>
